<div class="flex items-center w-full range-slider">
  <span class="slider-value">{{ minDisplayValue || value.minValue }}</span>
  <mat-slider [min]="minimum" [max]="maximum" [step]="minDifference" [discrete]="!hideThumbLabelText" [displayWith]="formatLabel">
    <input [value]="minValue" (valueChange)="onMinChange($event)" matSliderStartThumb>
    <input [value]="maxValue" (valueChange)="onMaxChange($event)" matSliderEndThumb>
  </mat-slider>
  <span class="slider-value">{{ maxDisplayValue || value.maxValue }}</span>
</div>

